import { useEffect, useState } from "react";
const BASEURL = process.env.REACT_APP_BASE_URL;

const useBinCleanUpDetails = ({
  city,
  fromDate,
  toDate,
  setTotalTspCount,
  setCleanTspCount
}: {
  city: string;
  fromDate: string;
  toDate: string;
  setTotalTspCount: any;
  setCleanTspCount: any;
}) => {
  const [binCleanUpData, setBinCleanupData] = useState<{
    servicedCount: number;
    totalCount: number;
    labels: any[];
    datasets: any[];
  }>({
    servicedCount: 0,
    totalCount: 0,
    labels: [],
    datasets: [
      {
        label: "Bin Clean up",
        data: [0],
        borderColor: "#ADD8E6",
        backgroundColor: "#ADD8E6"
      }
    ]
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${BASEURL}/v1/insights/bincleanup?city=${city}&to=${toDate}&from=${fromDate}`,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        const result = await response.json();
        const dates = Object.keys(result.data.binCleanUpData);
        dates.shift();

        const totalTsp = result.data.binCleanUpData.totalTsp ?? 0;
        let servicedCount = 0;

        if (dates.length) {
          const propertiesCovered = dates.map((date) =>
            Number(result.data.binCleanUpData[date].propertiesCovered)
          );

          servicedCount = propertiesCovered.reduce((a, b) => a + b, 0);

          if (!didCancel) {
            setTotalTspCount(totalTsp);
            setCleanTspCount(servicedCount);
            setBinCleanupData({
              servicedCount,
              totalCount: totalTsp,
              labels: dates,
              datasets: [
                {
                  label: "Bin Clean up",
                  data: propertiesCovered,
                  borderColor: "#ADD8E6",
                  backgroundColor: "#ADD8E6"
                }
              ]
            });
          }
        } else {
          if (!didCancel) {
            setTotalTspCount(0);
            setCleanTspCount(0);
            setBinCleanupData({
              servicedCount: 0,
              totalCount: 0,
              labels: [],
              datasets: [
                {
                  label: "Bin Clean up",
                  data: [0],
                  borderColor: "#ADD8E6",
                  backgroundColor: "#ADD8E6"
                }
              ]
            });
          }
        }

        didCancel = true;
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [city, toDate, fromDate]);

  return { binCleanUpData, loading, error };
};

export default useBinCleanUpDetails;
